import { Controller } from "@hotwired/stimulus"

// GSM-7 character sets (mirrors TwilioSegmentCalculator)
const GSM_7BIT_BASIC =
  "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ\x1BÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà"
const GSM_7BIT_EXTENDED = new Set("^{}\\[~]|€")

function isGsm7Compatible(message) {
  for (const char of message) {
    if (!GSM_7BIT_BASIC.includes(char) && !GSM_7BIT_EXTENDED.has(char)) {
      return false
    }
  }
  return true
}

function segmentsFor(message) {
  if (!message || message.length === 0) return 0

  if (isGsm7Compatible(message)) {
    let length = 0
    for (const char of message) {
      length += GSM_7BIT_EXTENDED.has(char) ? 2 : 1
    }
    return length <= 160 ? 1 : Math.ceil(length / 153)
  } else {
    const length = message.length
    return length <= 70 ? 1 : Math.ceil(length / 67)
  }
}

export default class extends Controller {
  static targets = ["textarea", "segmentInfo", "submitButton"]
  static values = { costPerSegment: Number, includedRemaining: Number }

  connect() {
    this.update()
  }

  update() {
    const body = this.textareaTarget.value
    const segments = segmentsFor(body)
    const hasAllowance = this.includedRemainingValue >= 0
    const billable = hasAllowance
      ? Math.max(0, segments - this.includedRemainingValue)
      : segments
    const cost = (billable * this.costPerSegmentValue).toFixed(2)

    if (segments === 0) {
      this.segmentInfoTarget.textContent = ""
    } else {
      const segmentLabel = segments === 1 ? "segment" : "segments"
      const suffix = hasAllowance && billable === 0 ? "included" : `est. $${cost}`
      this.segmentInfoTarget.textContent = `${segments} ${segmentLabel} · ${suffix}`
    }

    this.submitButtonTarget.disabled = body.trim().length === 0
  }
}
